// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'e8ba61f5-e7be-44d2-ae2c-e6714697b144',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'b8fa0367-2837-49f7-abf3-bf4e571ee761',
      type: 'Sprite',
      name: 'rewardIcon',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coin_Icon',
      parent: 'e8ba61f5-e7be-44d2-ae2c-e6714697b144',
      data: {
        maxSize: 75
      }
    },
    {
      id: '4e26f6ed-87b7-4042-9a8c-d38f6bcabfb5',
      type: 'Text',
      name: 'amountText',
      className: '',
      x: 0,
      y: 56,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'xXX',
      localize: false,
      maxWidth: 90,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#0e60ad',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'e8ba61f5-e7be-44d2-ae2c-e6714697b144',
      stateByName: {
        dark: {
          style: {
            stroke: '#2a288b'
          }
        }
      }
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '3.1.0',
  stateNames: [
    'dark'
  ],
  handleResize: false
} as const;

export class LuckyWheelRewardWedgeLayout {
  static raw = raw;
  root!: Container;
  rewardIcon!: Sprite & { data: typeof raw['list'][1]['data'] };
  amountText!: Text;
  StateName!: 'dark';

  constructor() {
    populate(this, raw);
  }
}
